// src/store/reports.ts
import { defineStore } from 'pinia';
import reportsAPI from '@/api/reports';
import { useAlertStore } from '@/store/alertStore';

function downloadBlob(blob: Blob, filename: string) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.setAttribute('download', filename);
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export const useReportsStore = defineStore('reports', () => {
  const alertStore = useAlertStore();

  const exportPDF = async (params: { from?: string; to?: string; scope?: string }) => {
    try {
      const res = await reportsAPI.exportPDF(params);
      const from = params.from || 'todos';
      const to = params.to || 'los_tiempos';
      downloadBlob(res.data, `reporte_${from}_${to}.pdf`);
    } catch (err: any) {
      alertStore.showAlert(
        err?.response?.data?.message || 'No se pudo exportar el PDF.',
        'error'
      );
      throw err;
    }
  };

  const exportExcel = async (params: { from?: string; to?: string; scope?: string }) => {
    try {
      const res = await reportsAPI.exportExcel(params);
      const from = params.from || 'todos';
      const to = params.to || 'los_tiempos';
      downloadBlob(res.data, `reporte_${from}_${to}.xlsx`);
    } catch (err: any) {
      alertStore.showAlert(
        err?.response?.data?.message || 'No se pudo exportar el Excel.',
        'error'
      );
      throw err;
    }
  };

  return { exportPDF, exportExcel };
});
